/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = CUSTOMER
 *
 * 1 = DEALER
 *
 * 2 = WARRANTY
 *
 * 3 = CONTRACT
 *
 * 4 = OTHER
 */
export enum RepairOrderJobLinePayer {
  CUSTOMER = 0,
  DEALER = 1,
  WARRANTY = 2,
  CONTRACT = 3,
  OTHER = 4,
}
